import { LoadingSkeleton } from 'sonata-react-components';

import './doohReportSkeleton.scss';

export default function DoohReportSkeleton() {
  return (
    <div className="doohReportSkeleton">
      <div className="doohReportSkeleton__audience">
        <LoadingSkeleton height={154} width={154} />
        <div className="doohReportSkeleton__audienceTexts">
          <LoadingSkeleton height={28} width="55%" />
          <LoadingSkeleton height={24} width="40%" />
        </div>
      </div>
      <div className="doohReportSkeleton__cards">
        {Array.from({ length: 3 }).map((_, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton — index is stable
          <div className="doohReportSkeleton__card" key={index}>
            <div className="doohReportSkeleton__cardTop">
              <LoadingSkeleton height={40} width={40} />
              <LoadingSkeleton height={32} width="50%" />
            </div>
            <LoadingSkeleton height={14} width="60%" />
            <LoadingSkeleton height={12} width="75%" />
          </div>
        ))}
      </div>
      <div className="doohReportSkeleton__section">
        {Array.from({ length: 5 }).map((_, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton — index is stable
          <LoadingSkeleton height={44} key={index} />
        ))}
      </div>
      <div className="doohReportSkeleton__section">
        {Array.from({ length: 5 }).map((_, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton — index is stable
          <LoadingSkeleton height={64} key={index} />
        ))}
      </div>
    </div>
  );
}
